import { render } from "./login-backup.vue?vue&type=template&id=3276d4b0&scoped=true"
import script from "./login-backup.vue?vue&type=script&lang=js"
export * from "./login-backup.vue?vue&type=script&lang=js"

import "./login-backup.vue?vue&type=style&index=0&id=3276d4b0&lang=less&scoped=true"

import exportComponent from "D:\\workspace\\payment-system-merchant\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3276d4b0"]])

export default __exports__